import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import CustomTextInput from '../atoms/custom-text-input.atom';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 24,
    width: '100%'
  },
  cell: {
    flex: 1
  },
  input: {
    textAlign: 'center',
    padding: '8px 0',
    fontSize: '24px',
    fontFamily: 'Inter',
    width: '100%',
    WebkitAppearance: 'none',
    margin: 0
  }
};

const OtpInput = ({ otpCode, onOtpCodeInput, numberOfCells = 5, additionalInputProps = {} }) => {
  const inputRefs = useRef([]);
  
  useEffect(() => {
    // Initialize refs array
    inputRefs.current = inputRefs.current.slice(0, numberOfCells);
  }, [numberOfCells]);

  const handleInputChange = (e, index) => {
    const value = e;
    const newValue = value.replace(/[^0-9]/g, '').slice(0, 1);
    
    const updatedOtp = otpCode.split('');
    updatedOtp[index] = newValue;
    onOtpCodeInput(updatedOtp.join(''));

    // Handle auto-focus
    if (newValue !== '') {
      if (index < numberOfCells - 1) {
        const nextInput = inputRefs.current[index + 1];
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (index > 0) {
        const prevInput = inputRefs.current[index - 1];
        if (prevInput) {
          prevInput.focus();
        }
      }
    }
  };
  
  return (
    <div style={styles.container}>
      {Array(numberOfCells).fill('').map((_, index) => (
        <div key={index} style={styles.cell}>
          <CustomTextInput
            onKeyDown={(e) => handleKeyDown(e, index)}
            value={otpCode[index] || ''}
            onChange={(e) => handleInputChange(e, index)}
            type="number"
            maxLength={1}
            ref= {(ref) => (inputRefs.current[index] = ref)}
            {...additionalInputProps}
          />
        </div>
      ))}
    </div>
  );
};

OtpInput.propTypes = {
  otpCode: PropTypes.string.isRequired,
  onOtpCodeInput: PropTypes.func.isRequired,
  numberOfCells: PropTypes.number
};

export default OtpInput;